export const addCourseConfidenceModalReducerActions = {
	OPEN: 0,
	HIDE: 1,
};

export const addCourseConfidenceModalReducer = (state, action) => {
	switch (action.type) {
		case addCourseConfidenceModalReducerActions.OPEN:
			return { ...state, show: true, data: action.payload };

		case addCourseConfidenceModalReducerActions.HIDE:
			return { ...state, show: false, data: undefined };

		default:
			throw Error("undefined action at addCoursePurchaseModalReducer");
	}
};

export const initialAddCourseConfidenceModalReducer = {
	show: false,
	data: undefined,
};
